export default __webpack_public_path__ + "static/media/614.4824e9cc.jpg";